import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { Loader2, X, CheckCircle2 } from 'lucide-react';
import './Counselling.css';

const ConfirmationModal = ({
    isOpen,
    onClose,
    selectedDate,
    selectedTime,
    initiatePayment,
    isBooking,
    appliedCoupon,
    couponError,
    couponLoading,
    priceDetails,
    handleApplyCoupon,
    handleRemoveCoupon,
}) => {
    const [localCouponCode, setLocalCouponCode] = useState('');

    useEffect(() => {
        if (appliedCoupon) {
            setLocalCouponCode(appliedCoupon.code);
        } else {
            setLocalCouponCode('');
        }
    }, [appliedCoupon]);

    if (!isOpen) {
        return null;
    }

    const onRemoveClick = () => {
        handleRemoveCoupon();
    };

    return (
        // ✅ CHANGED: Removed onClick={onClose} from this line
        <div className="modal-overlay">
            <div className="modal-content-1" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}><X size={24} /></button>
                
                <h2>Confirm Your Booking</h2>
                <p className="modal-subtitle">Please review your session details before payment.</p>

                <div className="modal-details">
                    <div className="modal-detail-item">
                        <span>Date:</span>
                        <strong>{format(selectedDate, 'EEEE, dd MMMM yyyy')}</strong>
                    </div>
                    <div className="modal-detail-item">
                        <span>Time:</span>
                        <strong>{selectedTime}</strong>
                    </div>
                </div>

                <div className="coupon-section-modal">
                    {!appliedCoupon ? (
                        <>
                            <div className="coupon-input-group">
                                <input
                                    type="text"
                                    placeholder="Enter Coupon Code"
                                    className={`coupon-input ${couponError ? 'input-error' : ''}`}
                                    value={localCouponCode}
                                    onChange={(e) => setLocalCouponCode(e.target.value)}
                                    disabled={couponLoading}
                                />
                                <button onClick={() => handleApplyCoupon(localCouponCode)} className="apply-coupon-btn" disabled={!localCouponCode || couponLoading}>
                                    {couponLoading ? <Loader2 size={16} className="animate-spin" /> : 'Apply'}
                                </button>
                            </div>
                            {couponError && <p className="coupon-error">{couponError}</p>}
                        </>
                    ) : (
                        <div className="coupon-applied-info full-width">
                            <p className="coupon-success-msg">
                                <CheckCircle2 size={16} />
                                Coupon <strong>"{appliedCoupon.code}"</strong> applied!
                            </p>
                            <button onClick={onRemoveClick} className="remove-coupon-btn">Remove</button>
                        </div>
                    )}
                </div>

                <div className="modal-price-summary">
                    <div className="price-row">
                        <span>Original Price</span>
                        <span>₹{Number(priceDetails.original).toFixed(2)}</span>
                    </div>
                    {appliedCoupon && (
                         <div className="price-row discount">
                            <span>Discount</span>
                            <span>- ₹{Number(priceDetails.discount).toFixed(2)}</span>
                        </div>
                    )}
                    <div className="price-row">
                        <span>Subtotal</span>
                        <span>₹{(Number(priceDetails.original) - Number(priceDetails.discount)).toFixed(2)}</span>
                    </div>
                    <div className="price-row">
                        <span>GST (18%)</span>
                        <span>+ ₹{Number(priceDetails.gst).toFixed(2)}</span>
                    </div>
                    <div className="price-row total">
                        <span>Total to Pay</span>
                        <span>₹{Number(priceDetails.final).toFixed(2)}</span>
                    </div>
                </div>
                
                <button className="modal-confirm-btn" onClick={initiatePayment} disabled={isBooking}>
                    {isBooking ? <><Loader2 className="animate-spin" size={20} /><span>Processing...</span></> : `Confirm & Pay ₹${Number(priceDetails.final).toFixed(2)}`}
                </button>
            </div>
        </div>
    );
};

export default ConfirmationModal;